import $ from 'jquery';
import Watcher from '../watcher';
import {isPhone} from '../useragent';

function isEven(n: number) {
    return n % 2 == 0;
}

if (isPhone) {
    $('section.new-scaling-layout > section > div').each((index, ele) => {
        $(ele).addClass(`padding-${isEven(index) ? 'right' : 'left'}`);
    });
}

const watcher = new Watcher();

{
    const $images = $('section.new-scaling-layout .img-container');

    const SPEED = 1.2;
    const startWidth = 85; //%
    const startHeight = 85; //%
    const widthDiv = 100 - startWidth; // % Breite soll auf 100% wachsen
    const heightDiv = 100 - startHeight; // % Höhe soll auf 100% wachsen

    $images.each((index, ele) => {
        watcher.add({
            element: $(ele).find('figure')[0],
            onProgress: (element, {upperProgress}) => {
                const progress = upperProgress;
                const mask = $(ele).find('.mask')[0];
                const width = startWidth + widthDiv * Math.min(1, progress * SPEED); // %
                const height = startHeight + heightDiv * Math.min(1, progress * SPEED); // %

                mask.style.width = `${width}%`;
                mask.style.height = `${height}%`;
            },
        });
    });
}

$('section.new-scaling-layout .emerge.words').each((index, ele) => {
    watcher.add({
        element: ele,
        onAppearing(element, direction) {
            $(ele).addClass('emerge-show');
        },
        onDisappeared(element, direction) {
            if (direction == -1) {
                $(ele).removeClass('emerge-show');
            }
        },
    });
});
